/** Upgrade http asset URLs to https to avoid mixed-content warnings on HTTPS pages. */
export function secureAssetUrl(url) {
  if (!url || typeof url !== "string") return url;
  const trimmed = url.trim();
  if (/^http:\/\//i.test(trimmed)) {
    return trimmed.replace(/^http:\/\//i, "https://");
  }
  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }
  return trimmed;
}

/** @deprecated alias kept for imports */
export const secureUrl = secureAssetUrl;
